// extracted by mini-css-extract-plugin
export default {"formContent":"oIO1FTowtE","message":"dtYM2BBkr8"};